import { Dispatch, Action } from 'redux';
import { pathOr } from 'ramda';
import { Event, ABAService } from './types';
import { actionFromShellEvent, shellEventFromAction } from './converter';
import { setParamAmsSegments } from './actions';
import {
  CHANGE_LANGUAGE_ERROR,
  CHANGE_PAGE,
  GET_PARAM_BASE_URL,
  GET_PARAM_BRAND,
  GET_PARAM_CHANNEL,
  GET_PARAM_CONTAINER,
  GET_PARAM_DEPOSIT_URL,
  GET_PARAM_LANGUAGE,
  GET_PARAM_PROXY_PREFIX,
  GET_PARAM_USER_DATA,
  GET_PARAM_CLIENT_ID,
  GET_PARAM_PLATFORM,
  GET_PARAM_USER_TOKEN,
  GET_PARAM_WITHDRAWAL_URL,
  GET_PARAM_LAYOUT_DIMENSIONS,
  REDIRECT_USER_BONUSES,
  REQUEST_LOGIN_MODAL,
  REQUEST_DEPOSIT_MODAL,
  REQUEST_APPLICATION_INSTALL_MODAL,
  SERVICE_RENDER_ERROR,
  REQUEST_UPDATE_BALANCE,
  CHANGE_INTERFACE_HEADER,
  REDIRECT_VIA_DEEP_LINK,
  REDIRECT_VIA_PLAIN_DEEP_LINK,
  CHANGE_CASHIER_RESULT_URL,
  CHANGE_AMS_SEGMENTS,
  GET_PARAM_AMS_SEGMENTS,
  GET_PARAM_THEME,
  GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  GET_PARAM_BRAND_HASH,
  GET_PARAM_APPLICATION_ID,
  GET_PARAM_OPERATOR_ID,
  GET_PARAM_API_KEY,
  UPDATE_NAVBAR,
} from './constants';

// Actions, which are used for notify shell about events or asking for data
export const PUBLISH_ACTIONS: Array<string> = [
  GET_PARAM_CONTAINER,
  GET_PARAM_LANGUAGE,
  GET_PARAM_BASE_URL,
  GET_PARAM_BRAND,
  GET_PARAM_CHANNEL,
  GET_PARAM_PROXY_PREFIX,
  GET_PARAM_AMS_SEGMENTS,
  GET_PARAM_USER_TOKEN,
  GET_PARAM_DEPOSIT_URL,
  GET_PARAM_WITHDRAWAL_URL,
  GET_PARAM_USER_DATA,
  GET_PARAM_CLIENT_ID,
  GET_PARAM_PLATFORM,
  GET_PARAM_LAYOUT_DIMENSIONS,
  GET_PARAM_THEME,
  GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  GET_PARAM_BRAND_HASH,
  GET_PARAM_APPLICATION_ID,
  GET_PARAM_OPERATOR_ID,
  GET_PARAM_API_KEY,
  // Request modals
  REQUEST_LOGIN_MODAL,
  REQUEST_DEPOSIT_MODAL,
  REQUEST_APPLICATION_INSTALL_MODAL,
  // Request updates
  REQUEST_UPDATE_BALANCE,
  // errors
  SERVICE_RENDER_ERROR,
  CHANGE_LANGUAGE_ERROR,
  // route
  CHANGE_PAGE,
  REDIRECT_USER_BONUSES,
  // redirects
  REDIRECT_VIA_DEEP_LINK,
  REDIRECT_VIA_PLAIN_DEEP_LINK,
  CHANGE_CASHIER_RESULT_URL,
  // interface
  CHANGE_INTERFACE_HEADER,
  UPDATE_NAVBAR,
];

export function createABAMiddleware(service: ABAService) {
  // @ts-ignore
  return ({ dispatch }) => {
    // listener
    service.onMessage((event: Event): void => {
      dispatch(actionFromShellEvent(event));
    });

    return (next: Dispatch) => (action: Action) => {
      if (action.type === CHANGE_AMS_SEGMENTS) {
        const result = next(action);
        dispatch(setParamAmsSegments(pathOr([], ['payload'], action)));
        return result;
      } else if (PUBLISH_ACTIONS.includes(action.type)) {
        const result = next(action);
        const { type, id, payload } = shellEventFromAction(action);
        service.publish(type, id, payload);

        return result;
      } else {
        return next(action);
      }
    };
  };
}
